import { render } from "./BigCount.vue?vue&type=template&id=151a5dda&scoped=true"
import script from "./BigCount.vue?vue&type=script&lang=js"
export * from "./BigCount.vue?vue&type=script&lang=js"

import "./BigCount.vue?vue&type=style&index=0&id=151a5dda&scoped=true&lang=css"

import exportComponent from "/Users/peter/www/standup-timer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151a5dda"]])

export default __exports__